import React, { createContext, useContext, useState } from 'react';

const StateContext = createContext();
const baseUrl = 'https://www.googleapis.com/customsearch/v1';

export const StateContextProvider = ({ children }) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const getResults = async (url) => {
    try {
      setLoading(true);

      const res = await fetch(`${baseUrl}?key=${process.env.REACT_APP_API_KEY}${url}&cx=${process.env.REACT_APP_SEARCH_ENGINE}`, {
        method: 'GET',
        headers: {
        },
      });

      const data = await res.json();

      setResults(data);
      setLoading(false);
    } catch (e) {
      // console.log(e);
    }
  };

  return (
    <StateContext.Provider value={{ getResults, results, searchTerm, setSearchTerm, loading }}>
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
